export default {"src":"/_next/static/media/feature-1.faed3aea.svg","height":650,"width":877,"blurWidth":0,"blurHeight":0};